import EtherscanStyleTxDetails from '../components/transaction/EtherscanStyleTxDetails';
import PrcPlatformTxDetails from '../components/transaction/PrcPlatformTxDetails';
import { usePrcTransaction } from '../hooks/usePrcTransaction';

function PrcTransactionDetailsView({ hash }) {
  const { display, loading, error } = usePrcTransaction(hash);
  const activityType = display?.activityType;

  if (activityType === 'deposit' || activityType === 'withdrawal' || activityType === 'trade') {
    return (
      <PrcPlatformTxDetails
        display={display}
        loading={loading}
        error={error}
      />
    );
  }

  return (
    <EtherscanStyleTxDetails
      display={display}
      loading={loading}
      error={error}
      title="Transaction Details"
    />
  );
}

export default PrcTransactionDetailsView;
